import {
	HttpRequest,
	HttpErrorResponse,
	HttpHandlerFn,
	HttpInterceptorFn,
} from '@angular/common/http';
import { ErrorManagerService } from '../../services/error-manager.service';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { ModalService } from '../../services/modal.service';
import { LocalStorageService } from '../../services/localstorageService.service';

export const errorInterceptor: HttpInterceptorFn = (
	req: HttpRequest<any>,
	next: HttpHandlerFn
) => {
	const errorManagerService = inject(ErrorManagerService);
	const userService = inject(UserService);
	const router = inject(Router);
	const modalService = inject(ModalService);
	const localStorageService = inject(LocalStorageService);
	const token = localStorageService.getToken();
	errorManagerService.clearException();

	let registerCompleted: boolean;

	localStorageService.registerCompleted.subscribe((res) => {
		if (res == undefined) {
			registerCompleted = false;
		} else registerCompleted = res;
	});

	if (token) {
		req = req.clone({
			setHeaders: {
				Authorization: `Bearer ${token}`,
			},
		});
	}

	return next(req).pipe(
		catchError((error: any) => {
			if (error.error.errorCode == 400) {
				errorManagerService.addException(error.error);
			}
			if (error.error.errorCode == 401 && !registerCompleted) {
				userService.logout();
				router.navigate(['/home']);
				modalService.openModal('sessionExpired');
				setTimeout(() => {
					modalService.closeModal('sessionExpired');
					registerCompleted = false;
				}, 3000);
			}
			if (error.error.errorCode == 401 && registerCompleted) {
				modalService.openModal('sendEmail');
			}

			return throwError(() => {
				error;
			});
		})
	);
};
